import type { PrimaryCountryISO } from '@/constants/countries';
// import exchanges from '@/constants/exchanges';
import md5 from 'md5';

export const getPriceTypeText = (market: PrimaryCountryISO) => {
  // In British English, "shares" is more commonly used than stocks, especially when discussing individual listed companies. In American English, "stocks" is more commonly used.
  const labelBase = market.toUpperCase() === 'GB' ? 'Share' : 'Stock';
  return {
    priceLabel: `${labelBase} Price`,
    securityLabel: labelBase,
  };
};

const exchangeCaseConversion = {
  NASDAQGS: 'NasdaqGS',
  NASDAQGM: 'NasdaqGM',
  NASDAQCM: 'NasdaqCM',
} as const;

/**
 * Conversion is required because the API is case-sensitive
 */
export const convertExchange = (rawExchange: string) => {
  if (rawExchange.length === 0) {
    throw new Error('Invalid exchange length');
  }

  // TODO: This needs improvements - it shouldn't need a casing replacement - the api should be case insensitive
  const exchange = rawExchange.toUpperCase();
  const exchangeFixed = exchangeCaseConversion[exchange] ?? exchange;

  return exchangeFixed;
};

export const getCompanyStockUrl = (uniqueSymbol: string) => {
  const [exchange, ...ticker] = uniqueSymbol.toLowerCase().split(':');
  return `/stock/${exchange}/${ticker.join('-')}`.toLowerCase();
};

/**
 * Returns a random set of n items from the given array (default 4).
 */

export const getRandomItems = <T extends { companyId: string }>(
  array: T[],
  n = 4,
  seed: string = ''
): T[] => {
  if (array.length <= n) return array.slice();

  // Sort using md5 hash of companyId + seed
  const sorted = array.slice().sort((a, b) => {
    const aHash = md5(a.companyId + seed);
    const bHash = md5(b.companyId + seed);
    // Compare as unsigned integers
    return parseInt(aHash.slice(0, 8), 16) - parseInt(bHash.slice(0, 8), 16);
  });

  // Offset the window based on the md5 hash of the seed
  const offset = parseInt(md5(seed).slice(0, 8), 16) % (array.length - n + 1);
  return sorted.slice(offset, offset + n);
};
